import { registerLocaleData } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { EditorModule } from '@tinymce/tinymce-angular';
import { BlockUIModule } from 'ng-block-ui';
import { AngularMaterialModule } from './angular-material.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminComponent } from './components/admin/admin.component';
import { ChampionAndPichichiComponent } from './components/champion-and-pichichi/champion-and-pichichi.component';
import { CommunicationDetailComponent } from './components/communications/communication-detail/communication-detail.component';
import { CommunicationsListComponent } from './components/communications/communications-list/communications-list.component';
import { EmailTemplateEditComponent } from './components/email-templates/email-template-edit/email-template-edit.component';
import { EmailTemplatesListComponent } from './components/email-templates/email-templates-list/email-templates-list.component';
import { FinalResultComponent } from './components/final-result/final-result.component';
import { GroupsComponent } from './components/groups/groups.component';
import { GroupDetailComponent } from './components/group-detail/group-detail.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { MatchesComponent } from './components/matches/matches.component';
import { PollComponent } from './components/poll/poll.component';
import { ProfileComponent } from './components/profile/profile.component';
import { PromptModalComponent } from './components/prompt-modal/prompt-modal.component';
import { RestoreComponent } from './components/restore/restore.component';
import { RoundSummariesComponent } from './components/round-summaries/round-summaries.component';
import { RulesComponent } from './components/rules/rules.component';
import { AvatarComponent } from './components/shared/avatar/avatar.component';
import { BadgeBookModalComponent } from './components/shared/badge-book-modal/badge-book-modal.component';
import { BadgeUnlockModalComponent } from './components/shared/badge-unlock-modal/badge-unlock-modal.component';
import { ConfirmModalComponent } from './components/shared/confirm-modal/confirm-modal.component';
import { MatchesListComponent } from './components/shared/matches-list/matches-list.component';
import { MatchDaySummaryModalComponent } from './components/shared/match-day-summary-modal/match-day-summary-modal.component';
import { MatchStatsComponent } from './components/shared/match-stats/match-stats.component';
import { ParticipantsListComponent } from './components/shared/participants-list/participants-list.component';
import { StandingsEvolutionChartComponent } from './components/shared/standings-evolution-chart/standings-evolution-chart.component';
import { UsersListModalComponent } from './components/shared/users-list-modal/users-list-modal.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { SignupComponent } from './components/signup/signup.component';
import { StandingsComponent } from './components/standings/standings.component';
import { StatsBadgesComponent } from './components/stats-badges/stats-badges.component';
import { StatsEvolutionComponent } from './components/stats-evolution/stats-evolution.component';
import { StatsScorersComponent } from './components/stats-scorers/stats-scorers.component';
import { StatsGroupStandingsComponent } from './components/stats-group-standings/stats-group-standings.component';
import { StatsSnipersComponent } from './components/stats-snipers/stats-snipers.component';
import { StatsComponent } from './components/stats/stats.component';
import { UsersComponent } from './components/users/users.component';
import { WhatsAppStatusComponent } from './components/whatsapp-status/whatsapp-status.component';
import { BackgroundUrlPipe } from './pipes/background-url.pipe';

registerLocaleData(localeEs);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignupComponent,
    StandingsComponent,
    StatsComponent,
    StatsBadgesComponent,
    StatsEvolutionComponent,
    StatsScorersComponent,
    StatsGroupStandingsComponent,
    StatsSnipersComponent,
    HomeComponent,
    AdminComponent,
    MatchesComponent,
    UsersComponent,
    GroupsComponent,
    GroupDetailComponent,
    PromptModalComponent,
    MatchesListComponent,
    MatchStatsComponent,
    MatchDaySummaryModalComponent,
    ParticipantsListComponent,
    StandingsEvolutionChartComponent,
    ProfileComponent,
    PollComponent,
    RulesComponent,
    ChampionAndPichichiComponent,
    BackgroundUrlPipe,
    AvatarComponent,
    BadgeBookModalComponent,
    BadgeUnlockModalComponent,
    SidenavComponent,
    RestoreComponent,
    RoundSummariesComponent,
    FinalResultComponent,
    ConfirmModalComponent,
    UsersListModalComponent,
    EmailTemplatesListComponent,
    EmailTemplateEditComponent,
    CommunicationsListComponent,
    CommunicationDetailComponent,
    WhatsAppStatusComponent,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      // enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    AngularMaterialModule,
    BlockUIModule.forRoot(),
    EditorModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: 'es-ES' },
  ],
})
export class AppModule {}
